import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { SubHeader } from '../organizations/subheader';
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import { Grid } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { BreadCrumbsComponent } from '../../components/breadcrumbs/breadcrumbsComponent';
import Input from '../../components/input/input';
import { styles } from './groups-detail-styles';
import { styles as dictionaryStyles } from '../dictionary/dictionary-styles';
import { GroupMembers } from './group-member-selection';
import { Select } from '../../components/select/select';
import { Confirm } from '@codametrix/shared-views';
import { eligibleGroupTypeRoleIds, groupTypeIds, groupTypes } from './groups-constants';
const GroupsDetail = (props)=>{
    const classes = styles();
    const dictionaryClasses = dictionaryStyles();
    const { saveGroup, deleteGroup, dispatchNavigation, eligibleGroupMembers, addGroupMember } = props;
    const item = useSelector((appState)=>{
        return appState.group.selectedGroup;
    });
    const [selectedGroup, setSelectedGroup] = useState(item);
    const [deleteModalDisplayed, setDeleteDialogDisplayed] = useState(false);
    const handleInputChange = (event)=>{
        const target = event.target;
        const { value, name } = target;
        setSelectedGroup({
            ...selectedGroup,
            [name]: value
        });
    };
    const _handleFormSubmit = ()=>{
        saveGroup(selectedGroup);
    };
    const _confirmDelete = ()=>{
        if (selectedGroup.id) {
            deleteGroup(selectedGroup.id);
        } else {
            throw new Error('User attempted to delete group but group has not been created and delete button should not be displayed!');
        }
    };
    const _handleDelete = ()=>{
        setDeleteDialogDisplayed(true);
    };
    const anchorRef = useRef(null);
    const anchorButtonClick = ()=>{
        anchorRef.current.click();
    };
    const eligibleGroupMemberList = ()=>{
        const isCqaGroup = selectedGroup.groupType === groupTypeIds.CQA_GROUP;
        return [
            {
                groupTitle: isCqaGroup ? 'CQA Members' : 'Coding Members',
                groupRoleId: isCqaGroup ? eligibleGroupTypeRoleIds.CQA_CODER : eligibleGroupTypeRoleIds.CODER
            },
            {
                groupTitle: isCqaGroup ? 'CQA Managers' : 'Coding Managers',
                groupRoleId: isCqaGroup ? eligibleGroupTypeRoleIds.CQA_MANAGER : eligibleGroupTypeRoleIds.CODING_MANAGER
            }
        ];
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        sx: classes.root,
        children: [
            /*#__PURE__*/ _jsx(Confirm, {
                onConfirm: _confirmDelete,
                onDismiss: ()=>{
                    setDeleteDialogDisplayed(false);
                },
                display: deleteModalDisplayed,
                strings: {
                    proceed: 'Delete',
                    dismiss: 'Cancel'
                },
                title: "Are you sure you want to permanently delete this group?"
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        name: 'back',
                        variant: ButtonVariant.SECONDARY,
                        label: 'Return to group list',
                        onClick: anchorButtonClick
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        hidden: true,
                        ref: anchorRef,
                        href: '/cmx/admin/orgs/:id/groups',
                        "data-testid": 'back',
                        onClick: dispatchNavigation,
                        style: {
                            display: 'block',
                            textAlign: 'left',
                            paddingTop: '5px',
                            color: '#E5927D',
                            textDecoration: 'none',
                            outline: 'none'
                        },
                        children: 'Back to group list'
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Flex, {
                marginBottom: 5,
                children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                sx: classes.horizontal,
                children: [
                    /*#__PURE__*/ _jsx(SubHeader, {
                        title: 'Edit Group',
                        className: classes.text
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes.buttonGroup,
                        children: [
                            selectedGroup.id && /*#__PURE__*/ _jsx(Button, {
                                size: ButtonSize.MD,
                                name: 'save',
                                variant: ButtonVariant.PRIMARY,
                                label: 'Save',
                                onClick: _handleFormSubmit
                            }),
                            selectedGroup.id && /*#__PURE__*/ _jsx(Button, {
                                size: ButtonSize.MD,
                                name: 'back',
                                variant: ButtonVariant.SECONDARY,
                                label: 'Delete This Group',
                                onClick: _handleDelete
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                sx: classes.fieldsets,
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes.groupinformation,
                        children: [
                            /*#__PURE__*/ _jsx(Input, {
                                isRequired: true,
                                onChange: handleInputChange,
                                label: 'Group Name',
                                placeholder: 'Enter group name',
                                name: 'groupName',
                                dataTestId: 'groupNameInput',
                                value: selectedGroup.groupName,
                                isReadOnly: false
                            }),
                            /*#__PURE__*/ _jsxs(Grid, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        sx: dictionaryClasses.label,
                                        children: "Group Type"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        onChange: handleInputChange,
                                        name: 'groupType',
                                        dataTestId: 'grouptypeInput',
                                        items: groupTypes,
                                        value: selectedGroup.groupType,
                                        disabled: selectedGroup !== undefined
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        style: {
                            flexDirection: 'column'
                        },
                        children: eligibleGroupMemberList().map((eligibleGroupMember)=>{
                            return /*#__PURE__*/ _jsx(GroupMembers, {
                                eligibleGroupMembers: eligibleGroupMembers,
                                addGroupMember: addGroupMember,
                                selectedGroup: selectedGroup,
                                groupTitle: eligibleGroupMember.groupTitle,
                                groupRoleId: eligibleGroupMember.groupRoleId
                            });
                        })
                    })
                ]
            })
        ]
    });
};
GroupsDetail.displayName = 'GroupsDetail';
export { GroupsDetail };
